var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCrossRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.151,
    height: 21.15,
    viewBox: "0 0 21.151 21.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1483",
    transform: "translate(-1321 -235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_958",
    transform: "translate(1017.222 189.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,0H26V2.911H0Z",
    transform: "translate(306.544 45.527) rotate(45)",
    fill: "#ca0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    d: "M0,0H26V2.911H0Z",
    transform: "translate(303.778 64.619) rotate(-45)",
    fill: "#ca0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrossRed);
export default __webpack_public_path__ + "static/media/icon_cross_red.e5fb40eafde7cca66eca024232a287e9.svg";
export { ForwardRef as ReactComponent };